export default "__VITE_ASSET__CDt$sfkY__"